import { DEPARTMENT_LIST, DEPARTMENT_DETAILS } from "./actions";

const initialState = {
  departmentList: {
    docs: [],
    totalDocs: 0,
    limit: 10,
    page: 1,
    totalPages: 0,
    pagingCounter: 0,
    hasPrevPage: false,
    hasNextPage: false,
    prevPage: null,
    nextPage: null,
  },
  getDepartmentData: {},
  loading: true,
};

const deptReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case DEPARTMENT_LIST:
      return {
        ...state,
        departmentList: payload,
        loading: false,
      };
    case DEPARTMENT_DETAILS:
      return {
        ...state,
        getDepartmentData: payload,
        loading: false,
      };
    default:
      return state;
  }
};
export default deptReducer;
